<script>
import ModelCreate from "../models/create-v2";
import FormsModel from "@/components/forms/weight-note.vue";
import Swal from 'sweetalert2'
import {serialize} from "object-to-formdata";

export default {
  extends: ModelCreate,
  page: {
    title: "Create Weight Notes",
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t('weight_notes.singular'))
      }
    },
    resourceRoute: {default: 'weight_notes'},
    modelVariable: {default: 'weight_note'},
    form: {
      default() {
        return FormsModel;
      }
    },
    alerts: {
      default: () => {
        return [
          {
            message: 'Pastikan jumlah fiber sudah sesuai!',
            dismissAfter: 10,
          },
        ]
      }
    }
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('weight_notes.singular')),
      items: [
        {
          text: this.lodash.startCase(this.$t('weight_notes.singular')),
          href: "/unload",
        },
        {
          text: this.$t("Create New"),
          href: "/unload/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    requestBody(value) {
      let tripItemIds = []
      return {
        ...value,
        files: value.files.map(v => {
          return {path: v.file}
        }),
        sale_items: value.trip_items.map(v => v.sale_items.map(sale_item => {
          let item = {
            ...sale_item,
            initial_quantity: v.quantity,
            initial_size: v.size,
            initial_unit_price: v.unit_price,
            purchase_item_id: v.purchase_item_id,
            trip_item_id: v.id,
            product_id: v.purchase_item.purchase_order.product_id,
          }

          if (!tripItemIds.includes(item.trip_item_id)) {
            tripItemIds.push(item.trip_item_id)
          } else {
            item.initial_quantity = 0
          }

          return item
        })).flat(),
      }
    },
    store(value) {
      const saleOrder = this.requestBody(value)
      // return Promise.reject(saleOrder);
      return this.$axios.post('/sale_orders', (
          serialize({...saleOrder}, {indices: true, booleansAsIntegers: true})
      ));
    },
    storeSuccessAlert(something, id) {
      return Swal.fire({
        title: this.$t('Success') + '!',
        text: this.$t(`You've added {something} with id {id}`, {something, id}),
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      })
    },
    handleStore(value) {
      this.storing = true;
      this.store(value)
          .then((response) => {
            const {data: {data}} = response
            this.storeSuccessAlert(this.getModelName(value), (data || {}).id)
          })
          .then(() => {
            this.isEditing = false;
            return this.$router.back()
          })
          .catch((error) => this.failedAlert(error))
          .finally(() => {
            this.storing = false
          })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .card-form {
    .card-title:first-child {
      text-transform: uppercase !important;
    }
  }
}
</style>